export default __webpack_public_path__ + "static/media/to.bb355684.jpg";